<template>
  <MyCaseFlyoutComponent>
    <template #body>
      <MyCaseSection
        back-button
        @back-click="setMyCaseFlyoutName('core')">
        <template #header>
          <h5 class="mb-0">
            Rent Quarterly
          </h5>
        </template>
        <template #body>
          <QuarterlyRentalDisplay
            v-if="itemToRent"
            :item-to-rent="itemToRent"
            :disabled="formDisabled"
            @total-updated="totalUpdated"
            @price-loading="priceLoading = $event"/>
          <div
            v-if="itemToRent && !isExtending"
            class="bg-origami text-center mt-xxl p-md">
            <h4 class="text-plum">
              Heads up!
            </h4>
            <p>
              Your next shipment will include a rollover item to cover this slot.
            </p>
          </div>
        </template>
      </MyCaseSection>
    </template>
    <template #footer>
      <div
        v-if="hasPaymentMethod && !isUpdatingPayment">
        <div
          v-if="errors.length > 0"
          class="border bg-origami mb-md">
          <p class="fine-print text-orchid text-center my-sm">
            Error confirming rental
          </p>
          <ul class="fine-print text-orchid">
            <li
              v-for="(error, index) in errors"
              :key="index"
              v-html="error"/>
          </ul>
        </div>
        <SequinButton
          block
          :disabled="formDisabled || !hasPaymentMethod || priceLoading || checkoutLoading || !itemToRent"
          @click="confirmRental">
          Confirm Quarterly Rental{{ total !== null ? ` - ${formatPrice(total, false, false, true)}` : '' }}
        </SequinButton>
      </div>
    </template>
  </MyCaseFlyoutComponent>
</template>

<script setup>
import { computed, ref, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { formatPrice } from '@/utils/stringParsing.js'
import { useQuarterlyRentalsStore } from '@/stores/quarterlyRentals.js'
import { useCaseStore } from '@/stores/case.js'
import { useClientStore } from '@shared/stores/client.js'
import MyCaseFlyoutComponent from '../common/MyCaseFlyoutComponent'
import MyCaseSection from '../common/MyCaseSection'
import SequinButton from '../../global/sequin/SequinButton'
import QuarterlyRentalDisplay from './QuarterlyRentalDisplay.vue'


const caseStore = useCaseStore()
const clientStore = useClientStore()
const { rentItemQuarterly } = useQuarterlyRentalsStore()
const { errors } = storeToRefs(useQuarterlyRentalsStore())
const { itemToRent } = storeToRefs(caseStore)
const { defaultPayment, isUpdatingPayment } = storeToRefs(clientStore)
const checkoutLoading = ref(false)
const isExtending = computed(() => itemToRent.value?.extensionEligibility)

const formDisabled = ref(false)
const total = ref(null)
const remainingCredit = ref(0)
const priceLoading = ref(true)

const hasPaymentMethod = computed(() => Boolean(defaultPayment.value))

const setMyCaseFlyoutName = (name) => {
  caseStore.setMyCaseFlyoutName(name)
}

const totalUpdated = (newTotal, newRemainingCredit) => {
  total.value = newTotal
  remainingCredit.value = newRemainingCredit || 0
}

const confirmRental = async () => {
  if (!itemToRent.value?.id) return
  formDisabled.value = true
  checkoutLoading.value = true
  try {
    await rentItemQuarterly(itemToRent.value.id)
  } finally {
    checkoutLoading.value = false
    formDisabled.value = false
  }
}

onBeforeUnmount(() => {
  errors.value = []
})
</script>

<style lang="scss" scoped>
:deep(.section) {
  height: 100%;
  flex-grow: 1;
}
</style>